import SectionHeader from "../SectionHeader";

export default function ShopexOffer() {
  return (
    <>
      <SectionHeader>What Shopex Offer!</SectionHeader>
      <div className="w-full mt-8">
        <div className="flex justify-between max-w-5xl mx-auto">
          <Card img={require("../../assets/home/shopex-offer/img01.png")} />
          <Card img={require("../../assets/home/shopex-offer/img02.png")} />
          <Card img={require("../../assets/home/shopex-offer/img03.png")} />
          <Card img={require("../../assets/home/shopex-offer/img04.png")} />
        </div>
      </div>
    </>
  );
}

function Card({ img }) {
  return (
    <div className="w-60 flex flex-col items-center overflow-hidden pb-10 pt-12 px-6 text-center">
      {/* icons container */}
      <div className=" h-20 flex items-end">
        <img src={img} alt="" />
      </div>
      <h5 className="font-fontOne font-bold text-lg mt-6 mb-4 text-text">
        24/7 Support
      </h5>
      <p className="overflow-hidden max-h-[7rem] font-semibold text-[rgba(26,11,91,0.3)]">
        Voluptate incididunt amet eiusmod do magna deserunt.
      </p>
    </div>
  );
}
